import { render, staticRenderFns } from "./CateEdit.vue?vue&type=template&id=294884d4&scoped=true"
import script from "./CateEdit.vue?vue&type=script&lang=js"
export * from "./CateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294884d4",
  null
  
)

export default component.exports